import React, { useEffect } from 'react';
import AIs_V2 from '../Home_V2/AIs/AIs';

const DoItYourself_V2 = () => {
  useEffect(() => {
    window.scroll(0,0);
  } ,[])
  return (
    <section className="pb-4">
      <div className="">
        <AIs_V2 />
        <div className="text-center text-white" style={{ marginTop: '-30px' }}>
          <p>Feel free to create content however you like!</p>
        </div>
      </div>
    </section>
  );
};

export default DoItYourself_V2;
